import { createContext, useContext, type ReactNode } from "react";
import {
  useHeartRateSensor,
  type HeartRateSensorState,
} from "@/entities/heart-rate/lib/use-heart-rate-sensor";

const HeartRateContext = createContext<HeartRateSensorState | null>(null);

export function HeartRateProvider({ children }: { children: ReactNode }): React.JSX.Element {
  const value = useHeartRateSensor();
  return <HeartRateContext.Provider value={value}>{children}</HeartRateContext.Provider>;
}

export function useHeartRate(): HeartRateSensorState {
  const value = useContext(HeartRateContext);
  if (!value) throw new Error("useHeartRate must be used inside HeartRateProvider");
  return value;
}
